import React, { useEffect, useState } from "react";
import HomeContent from "../function-components/home/HomeContent";

//adding comments on home file
import {
  useAppInsightsContext,
  useTrackEvent,
} from "@microsoft/applicationinsights-react-js";
function Home() {
  //  async function fetchUserCount() {
  //   const instrumentationKey = "056c4eba-558d-42f8-9528-e8b102587cb8"; // Replace with your Instrumentation Key
  //   const apiUrl = `https://api.applicationinsights.io/v1/apps/${instrumentationKey}/metrics`;

  //   const query = {
  //    metricId: "uniqueUsers/count",
  //    timespan: "PT24H", // Adjust the timespan as needed
  //    aggregation: "count",
  //   };

  //   const response = await fetch(apiUrl, {
  //    method: "POST",
  //    headers: {
  //     "Content-Type": "application/json",
  //     "x-api-key": "YOUR_API_KEY", // Replace with your API key
  //    },
  //    body: JSON.stringify(query),
  //   });

  //   if (response.ok) {
  //    const data = await response.json();
  //    const userCount = data.value[0]?.timeseries[0]?.data[0]?.count;
  //    return userCount;
  //   } else {
  //    throw new Error("Failed to fetch user count");
  //   }
  //  }

  //const appInsights = useAppInsightsContext();
  //  useTrackMetric(appInsights, "Home");
  //useTrackEvent(appInsights, "FAQ");
  //const [userCount, setUserCount] = useState(null);

  //  useEffect(() => {
  //   async function fetchData() {
  //    try {
  //     const count = await fetchUserCount();
  //     setUserCount(count);
  //    } catch (error) {
  //     console.error("Error fetching user count:", error);
  //    }
  //   }

  //   fetchData();
  //  }, []);
  return (
    <>
      <HomeContent />
    </>
  );
}

export default Home;
